//=====================================================
//　Context宣言
//=====================================================
import { createContext } from "react";
import { IFUseAuth } from "./UseAuth";
import { IFUseOrder, IVOrder } from "./UseOrder";

//ユーザ認証Context
export const CtxAuth = createContext<IFUseAuth>({
    login: function(){},
    logout: function(){},
    getToken: function():string{return ""},
    getOperatorNo: function():string{return ""},
    isLoggedIn: function(){},
});

//注文フォーム情報
export const CtxOrder = createContext<IFUseOrder>({
   data: IVOrder,
   setData: function(){},
   useStart: function(){},
});

